var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.165,
    height: 69.292,
    viewBox: "0 0 56.165 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nodejs-stop",
    transform: "translate(0.002 -0.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#07d4bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#07d4bf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "nodejs",
    transform: "translate(266.117 -328.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M-235.632,378.071l-7.968-5.386v-9.414l7.678-4.362a.709.709,0,0,1,.668,0l7.255,4.384a.645.645,0,0,1,.312.579v9.414Z",
    transform: "translate(-3.498 -9.709)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(-248.078 346.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M-238.474,368.785l-3.071-1.847a.549.549,0,0,1-.2-.757h0a.549.549,0,0,1,.757-.2l2.515,1.491a.644.644,0,0,0,.69,0l7.923-4.807a.645.645,0,0,0,.312-.579V353.05a.671.671,0,0,0-.312-.579l-7.945-4.807a.654.654,0,0,0-.668-.022l-8.079,4.5a.622.622,0,0,0-.334.579v8.991a.7.7,0,0,0,.312.579l2.337,1.4a1.852,1.852,0,0,0,1.8,0,1.351,1.351,0,0,0,.779-1.135l-.022-8.346a.551.551,0,0,1,.556-.556h0a.551.551,0,0,1,.556.556l.022,8.346a2.413,2.413,0,0,1-1.358,2.114,2.9,2.9,0,0,1-2.916-.022l-2.871-1.691a.645.645,0,0,1-.312-.579v-10.26a.664.664,0,0,1,.334-.579l9.214-5.119a.654.654,0,0,1,.668.022l9.036,5.475a.645.645,0,0,1,.312.579v10.282a.7.7,0,0,1-.312.579l-9.036,5.475A.762.762,0,0,1-238.474,368.785Z",
    transform: "translate(248 -346.337)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(-239.53 353.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M-205.656,388.652a10.367,10.367,0,0,1-1.536-.111,3.1,3.1,0,0,1-2.359-1.558.537.537,0,0,1,.512-.734h.067a.54.54,0,0,1,.467.312c.312.69,1.469.89,1.491.89.734.111,2.827.245,3.784-.4a.9.9,0,0,0,.445-.645,1,1,0,0,0-.69-1.068,9.48,9.48,0,0,0-1.736-.4,16.143,16.143,0,0,1-2.515-.6,2.242,2.242,0,0,1-1.469-2.671v-.022c.4-1.469,2.515-1.6,2.76-1.6.445-.022,2.6-.134,3.583.69a3.215,3.215,0,0,1,.712,1.625v.156a.5.5,0,0,1-.913.178.253.253,0,0,1-.067-.178,1.352,1.352,0,0,0-.49-.979,5.262,5.262,0,0,0-2.737-.378c-.512.022-1.6.245-1.758.8v.022a1.111,1.111,0,0,0,.734,1.335,12.636,12.636,0,0,0,2.315.556,9.746,9.746,0,0,1,1.959.445,2.091,2.091,0,0,1,1.424,2.292,2.1,2.1,0,0,1-.912,1.4A6.259,6.259,0,0,1-205.656,388.652Z",
    transform: "translate(209.593 -380.022)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.0626486e58448c703b4641086ffbf168.svg";
export { ForwardRef as ReactComponent };